const enum FieldsForUpdateEnum {
    PRICE = 'price',
    AVAILABILITY = 'availability',
}

export default FieldsForUpdateEnum;